export default __webpack_public_path__ + "static/fun-2fbc9e6cadd5033ecdd0340fd60ed8ff.svg";